import React from 'react';
import styled from 'styled-components/native';
import PropTypes from 'prop-types';
import Colors from '../colors';
import Text from '../text';
import DocumentLink from '../document-link';
import Spacer from '../spacer';
const FlexOne = styled.View`
  flex: 1;
`;
const StyledContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
`;
export default function DocumentRow(props) {
  return /*#__PURE__*/React.createElement(StyledContainer, null, /*#__PURE__*/React.createElement(FlexOne, null, /*#__PURE__*/React.createElement(DocumentLink, {
    name: props.name,
    status: props.status
  })), /*#__PURE__*/React.createElement(Spacer, {
    size: "f8",
    width: true
  }), /*#__PURE__*/React.createElement(Text.BodyBase, {
    color: Colors.gray400
  }, props.children));
}
DocumentRow.propTypes = {
  children: PropTypes.string,
  name: PropTypes.string,
  status: PropTypes.string
};
DocumentRow.defaultProps = {
  children: '',
  name: '',
  status: ''
};
//# sourceMappingURL=index.js.map